<template>
    <!-- 常见问题 -->
    <div>
        <div>
            <div class="price-banner">
                <h2>选择适合您的方案，<span style="color: rgb(37, 84, 254)">0成本</span>提升管理效率</h2>
                <h6>投入灵活，轻松管理与运营多个跨境店铺</h6>
                <div class="guanliSty">
                    <div class="ysVersionCard">
                        <div class="ysVersionBox">
                            <div class="ysVersionCardTitle">免费版</div>
                            <div class="ysVersionCardSubtitle">适用：中小型企业</div>
                            <div class="flex items-center">
                                <span class="price"> 0 </span>
                                <div class="flex flex-col">
                                    <span class="price_detail">元/月</span>
                                    <span class="price_detail">≤2000月订单量</span>
                                </div>
                            </div>
                        </div>
                        <div class="supper">
                            <div class="supper_text">支持范围：</div>
                            <div class="ysVersionCardSubDescription">商品管理<i class="el-icon-check green font18"></i>
                            </div>
                            <div class="ysVersionCardSubDescription">订单管理<i class="el-icon-check green font18"></i>
                            </div>
                            <div class="ysVersionCardSubDescription">销售管理<i class="el-icon-check green font18"></i>
                            </div>
                            <div class="ysVersionCardSubDescription">利润精准核算一表呈现<i
                                    class="el-icon-check green font18"></i></div>
                        </div>
                        <a href="/contactUs" class="href_use flex items-center">免费使用</a>
                    </div>
                    <div class="ysVersionCard">
                        <div class="ysVersionBox">
                            <div class="ysVersionCardTitle">充值版</div>
                            <div class="ysVersionCardSubtitle">适用：中大型企业</div>
                            <div class="flex items-center ">
                                <span class="yue">约</span>
                                <span class="price">0.1</span>
                                <div class="flex flex-col">
                                    <span class="price_detail">元/单</span>
                                    <span class="price_detail">3年有效期</span>
                                </div>
                            </div>
                        </div>
                        <div class="supper">
                            <div class="supper_text">支持范围：</div>
                            <div class="ysVersionCardSubDescription">商品管理<i class="el-icon-check green font18"></i>
                            </div>
                            <div class="ysVersionCardSubDescription">订单管理<i class="el-icon-check green font18"></i>
                            </div>
                            <div class="ysVersionCardSubDescription">销售管理<i class="el-icon-check green font18"></i>
                            </div>
                            <div class="ysVersionCardSubDescription">免费实施上门培训<i class="el-icon-check green font18"></i>
                            </div>
                        </div>
                        <a href="/contactUs" class="href_use flex items-center">了解价格</a>
                    </div>
                    <div class="ysVersionCard">
                        <div class="ysVersionBox">
                            <div class="ysVersionCardTitle">定制版</div>
                            <div class="ysVersionCardSubtitle">适用：大型企业</div>
                            <div class="flex items-center h59">
                                <!-- <img src="../../assets/img/softwareProduct/download.png" alt="" style="margin-right: 10px;"> -->
                                <div class="flex flex-col">
                                    <span class="price_detail">按需定制</span>
                                    <span class="price_detail">付费灵活</span>
                                </div>
                            </div>
                        </div>
                        <div class="supper">
                            <div class="supper_text">支持范围：</div>
                            <div class="ysVersionCardSubDescription">商品管理<i class="el-icon-check green font18"></i>
                            </div>
                            <div class="ysVersionCardSubDescription">订单管理<i class="el-icon-check green font18"></i>
                            </div>
                            <div class="ysVersionCardSubDescription">销售管理<i class="el-icon-check green font18"></i>
                            </div>
                            <div class="ysVersionCardSubDescription">免费实施上门培训<i class="el-icon-check green font18"></i>
                            </div>
                        </div>
                        <a href="/contactUs" class="href_use flex items-center">了解价格</a>
                    </div>
                </div>
                <div class="diff">
                    <h3 class="diff_title">ERP版本对比</h3>
                    <div class="diff_desc">
                        每个版本均包含全系统功能与客户服务，有效提升运营管理效率
                    </div>
                </div>
                <div class="version">
                    <div class="version_header">
                        <div class="version_header_column1">差异项</div>
                        <div class="version_header_column2">
                            <div class="version_header_column2_title">免费版</div>
                            <div class="version_header_column2_desc">0元使用</div>
                        </div>
                        <div class="version_header_column2">
                            <div class="version_header_column2_title">充值版</div>
                            <div class="version_header_column2_desc">按单量灵活购买</div>
                        </div>
                    </div>
                    <div class="version_items">
                        <div class="version_items1">实施服务</div>
                        <div class="version_items2">线上免费实施服务</div>
                        <div class="version_items2">线上线下免费实施服务</div>
                    </div>
                    <!-- <div class="version_items">
                        <div class="version_items1">支持站点量</div>
                        <div class="version_items2">50</div>
                        <div class="version_items2">100</div>
                    </div> -->
                    <div class="version_items">
                        <div class="version_items1">子账号量</div>
                        <div class="version_items2">20</div>
                        <div class="version_items2">不限</div>
                    </div>
                    <div class="version_items">
                        <div class="version_items1">订单管理</div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                    </div>
                    <div class="version_items">
                        <div class="version_items1">商品管理</div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                    </div>
                    <div class="version_items">
                        <div class="version_items1">采购管理</div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                    </div>
                    <div class="version_items">
                        <div class="version_items1">销售管理</div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                    </div>
                    <div class="version_items">
                        <div class="version_items1">财务管理</div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                    </div>
                    <div class="version_items">
                        <div class="version_items1">进销存管理</div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                    </div>
                    <div class="version_items">
                        <div class="version_items1">开放接口，与多系统对接</div>
                        <div class="version_items2">
                            <i class="el-icon-close red font18 font24"></i>
                        </div>
                        <div class="version_items2">
                            <i class="el-icon-check green font18 font24"></i>
                        </div>
                    </div>
                    <div class="version_items">
                        <div class="version_items1">价格</div>
                        <div class="version_items2">0元使用</div>
                        <div class="version_items2">按单量灵活购买</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
export default {
    name: "YinshiOffcialwebsiteCommonProblem",

    data() {
        return {
            tableData: [],
        };
    },

    mounted() { },
    components: {
        Footer,
    },

    methods: {
        ...mapMutations(["GoTop"]),
    },
    created() {
        this.$store.state.currentRouter = this.$route.path; //获取当前页面路由
        this.GoTop();
    },
};
</script>

<style lang="scss" scoped>
.price-banner {
    // background: #f1f1f1;
    padding-top: 50px;
}

.price-banner h2 {
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 2.25rem;
    line-height: 50px;
    margin-bottom: 0.5rem;
    text-align: center;
}

.price-banner h6 {
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 1.125rem;
    color: #5c5e66;
    text-align: center;
}

.guanliSty {
    width: 1360px;
    display: flex;
    justify-content: space-between;
    margin: 50px auto;
}

.ysVersionCard {
    width: 280px;
    height: 470px;
    padding: 40px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-shadow: 0 0 10px 0 rgb(180 189 221 / 8%), 0 6px 14px 0 hsl(0deg 0% 100% / 30%), 0 20px 30px 0 rgb(180 189 221 / 25%);
}

.ysVersionBox {
    padding-bottom: 32px;
    border-bottom: 1px solid #e5e7eb;
    width: 100%;
}

.ysVersionCardTitle {
    font-size: 30px;
    line-height: 30px;
    margin-bottom: 12px;
    text-align: center;
}

.ysVersionCardSubtitle {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 24px;
    text-align: center;
    color: rgb(155, 158, 169);
}

.items-center {
    align-items: center;
    justify-content: center;
}

.price {
    color: #1a2035;
    font-size: 48px;
    line-height: 59px;
    font-weight: 700;
    margin-right: 0.5rem;
}

.flex {
    display: flex;
}

.flex-col {
    flex-direction: column;
}

.price_detail {
    font-size: 14px;
    line-height: 21px;
}

.price_detail {
    font-size: 14px;
    line-height: 21px;
}

.supper {
    padding: 24px 0 32px 0;
    width: 100%;
}

.supper_text {
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 500;
}

.ysVersionCardSubDescription {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    color: rgba(58, 64, 87, 0.9);
}

.el-icon-check:before {
    content: "\e6da";
}

[class*=" el-icon-"],
[class^=el-icon-] {
    font-family: element-icons !important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.green {
    color: rgba(0, 184, 0);
}

.font18 {
    font-size: 20px;
}

.href_use {
    background-color: #20407f;
    padding: 0 24px;
    border-radius: 5px;
    height: 56px;
    line-height: 56px;
    display: block;
    color: rgb(255, 255, 255);
    font-size: 24px;
    text-align: center;
    width: 230px;
}

.diff {
    margin-top: 120px;
}

.diff_title {
    text-align: center;
    font-size: 36px;
    font-weight: 500;
    line-height: 50px;
}

.diff_desc {
    text-align: center;
    font-size: 18px;
    font-weight: 300;
    line-height: 27px;
}

.version {
    width: 1280px;
    margin: 80px auto;
}

.version_header {
    height: 96px;
    border-bottom: 1px solid #eaeffb;
    background: #fff;
    top: 64px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.version_header_column1 {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    margin-left: 40px;
}

.version_header_column2 {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

.version_header_column2_title {
    font-size: 24px;
    line-height: 36px;
}

.version_header_column2_desc {
    font-size: 16px;
    line-height: 36px;
    color: rgb(26, 32, 53);
}

.version_items {
    display: grid;
    height: 50px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    border-bottom: 1px solid rgb(229, 231, 235);
}

.version_items1 {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    margin-left: 40px;
    --tw-text-opacity: 1;
    color: rgba(26, 32, 53, var(--tw-text-opacity));
}

.version_items2 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: .875rem;
    position: relative;
    text-align: center;
    --tw-text-opacity: 1;
    color: rgba(155, 158, 169, var(--tw-text-opacity));
}

.red {
    color: red;
}

.yue {
    margin-right: 5px;
}

.h59 {
    height: 60px;
}
</style>
